import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import "./DiscussionReportModal.scss"
import { getDetailReport, processDiscussionReports } from '../../../../../../service/course-management';
import { CopyOutlined } from '@ant-design/icons';
import { notifySuccess } from '../../../../../../utils/notification';
import { CourseManagementStore } from '../../../../../../stores/stores';

interface Props {
	open?: boolean
	handleCancel?: () => void
	reportId: number
	reportLevel?: number
}

const DiscussionReportModal = (props: Props) => {
  const { t } = useTranslation();
	const { open, handleCancel, reportId, reportLevel } = props
	const [detailReport, setDetailReport] = useState<any>({})
	const { reloadDiscussion, setReloadDiscussion } = CourseManagementStore()

	useEffect(() => {
		const fetchDetailReport = async () => {
			try {
				const res = await getDetailReport(reportId)
				setDetailReport(res?.data.data)
			} catch (error) {

			}
		}
		if (open) fetchDetailReport()
	}, [open, reportId])

	const handleRemoveCmt = () => {
		Modal.confirm({
			title: `Bạn có chắc chắn muốn gỡ ${reportLevel === 1 ? t("thảo luận", "thảo luận") : t("phản hồi", "phản hồi")}`,
			onOk: () => handleDiscussionReports(),
			okText: `Gỡ ${reportLevel === 1 ? t("thảo luận", "thảo luận") : t("phản hồi", "phản hồi")}`,
			cancelText: t("Huỷ", "Huỷ"),
			centered: true,
			icon: <CopyOutlined style={{ color: "#1677FF" }} />,
			footer: (_, { OkBtn, CancelBtn }) => (
				<>
					<CancelBtn />
					<OkBtn />
				</>
			),
		});
	};

	const handleDiscussionReports = async () => {
		try {
			const payload = {
				reportId: reportId,
				status: 1
			}
			await processDiscussionReports(payload)
			notifySuccess(`Gỡ ${reportLevel === 1 ? t("thảo luận", "thảo luận") : t("phản hồi", "phản hồi")} thành công`)
			handleCancel && handleCancel()
			setReloadDiscussion(!reloadDiscussion)
		} catch (error) {
		}
	}

	const handleOk = async () => {
		try {
			const payload = {
				reportId: reportId,
				status: 0
			}
			await processDiscussionReports(payload)
			handleCancel && handleCancel()
			setReloadDiscussion(!reloadDiscussion)
		} catch (error) {
		}
	}
	return (
		<Modal
			centered
			footer={
				<div className='flex gap-8'>
					<Button onClick={handleOk}>{t("Từ chối", "Từ chối")}</Button>
					<Button type="primary" onClick={handleRemoveCmt}>{t("Gỡ", "Gỡ")} {reportLevel === 1 ? t("thảo luận", "thảo luận") : t("phản hồi", "phản hồi")}</Button>
				</div>
			}
			title={t("Xử lý báo cáo", "Xử lý báo cáo")}
			open={open}
			onOk={handleOk}
			onCancel={handleCancel}
			className='discussion-report-modal'
		>
			{/* <div>{t("Lý do báo cáo", "Lý do báo cáo")}</div> */}
			<div className='text-description-14'>{t("Nội dung báo cáo", "Nội dung báo cáo")}</div>
			<div className="report-content">
				{detailReport?.content}
			</div>
		</Modal>
	)
}

export default DiscussionReportModal